'use strict';

import React from 'react';
import flux from 'utils/flux';
import Immutable from 'immutable';
import Thumb from 'components/thumb';
import prettyBytes from 'pretty-bytes';
import isEqual from 'lodash/lang/isEqual';

const InstantDownloadItem = React.createClass({
    displayName: 'InstantDownloadItem',

    propTypes: {
        media: React.PropTypes.object.isRequired,
    },

    shouldComponentUpdate( nextProps, nextState ) {
        return ( Immutable.is( nextProps.media, this.props.media ) === false || isEqual( nextState, this.state ) === false );
    },

    render() {
        let item = this.props.media.toJS();
        let itemTitle = (item.title && item.title.length) ? item.title : item.name;
        return(
                    <div className="instantdownload__item">
                        <div className="item__image">
                            <Thumb className="item__preview" media={this.props.media} onClickOpenModal={false} />
                        </div>

                        <div className="item__description">
                            <div className="description__download">
                                <table>
                                <colgroup>
                                    <col width="66%"/>
                                    <col width="17%"/>
                                    <col width="17%"/>
                                </colgroup> 
                                    <thead>
                                        <th className="item__title">{itemTitle}</th>
                                        <th>{flux.t('download_file_mimetype')}</th>
                                        <th>{flux.t('download_file_size')}</th>
                                    </thead>
                                    <tbody>
                                        {item.files.map((file) => {
                                            return (
                                                <tr key={'i-' + item.id + '-' + file.key}>
                                                    <td className="download__body--checkbox">
                                                        <div className="field__checkbox download__checkbox">
                                                            <input checked={file._selected} name={item.id} value={file.key} type="checkbox" readOnly />
                                                            <label onClick={this.props.toggleCheck.bind(null, file.key, item)} htmlFor="check__all">{file.name}</label>
                                                        </div>
                                                    </td>
                                                    <td>{file.mimeType}</td>
                                                    <td>{prettyBytes(file.size)}</td>
                                                </tr>);
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
        );
    }
});

module.exports = InstantDownloadItem;



// WEBPACK FOOTER //
// ./app/components/modals/instantDownloadItem.jsx